import { ContentSyncCoordinator, type ContentSyncConfig } from "./content-sync";
import { bonusReports } from "@/plugins/LocalForagePlugin";
import { bonusReportsSyncKey } from "@/types/products/product-keys";
import type { ContentfulBonusReport, NormalizedContent } from "@tmi/types/entities";
import type { BonusReports } from "@tmi/types/api/content-models";

import { consoleLoggerFactory, getDefaultLoggerOptions, LogLevels } from "@/types/console-logger";
const logger = consoleLoggerFactory.create( getDefaultLoggerOptions( LogLevels.DEBUG ) );

const config: ContentSyncConfig<BonusReports, ContentfulBonusReport> = {
    name: 'bonus-reports',
    store: () => bonusReports,
    syncKey: bonusReportsSyncKey,
    metaQueryId: '15f93c2aca36c4868db8e38ba5be5f4e',
    contentQueryId: 'dcb63ca81a12007ee8b590e75cd82457',
    contentPageSize: 350,
    extractMetaPayload: ( data ) => data.bonusReportCatalog?.bonus_reports,
    extractContentPayload: ( data ) => data.bonusReportCatalog?.bonus_reports,
    normalizeItem: normalizeBonusReport
};

export class BonusReportsSyncCoordinator {
    readonly #inner: ContentSyncCoordinator<BonusReports, ContentfulBonusReport>;
    constructor() {
        this.#inner = new ContentSyncCoordinator( config );
    }
    patchRepository( authToken: string ): Promise<number> {
        return this.#inner.patchRepository( authToken );
    }
}

export function normalizeBonusReport( report: ContentfulBonusReport ): NormalizedContent | undefined {
    try {
        return {
            contentfulId: report.id,
            publishedDate: report.pub_dt,
            updatedDate: report.publish_at,
            slug: report.slug ?? undefined,
            title: report.name ?? undefined,
            pdfLink: report.pdf_uri ?? undefined,
            thumbnail: report.thumbnail_uri ?? undefined,
            authorId: undefined,
            adProductId: undefined,
            categoryIds: report.assoc_cat_ids ?? [],
            industrySectorIds: [],
            productIds: report.assoc_product_ids ?? [],
            sectorIds: [],
            tagIds: report.assoc_tag_ids ?? [],
            tickerIds: []
        };
    } catch ( e: any ) {
        logger.error( `[ bonus-reports-sync-coordinator ] Failed to normalize bonus report '${ report.id }':`, e );
        return undefined;
    }
}
